import { useDispatch } from "react-redux";

import { dataActions } from "@src/services/state/dataReducer";
import type * as TDT from "@tradingdroid/frontends-types";

import { useDataState } from "./data";

export const useJobs = () => {
  const dispatch = useDispatch();
  const jobs = useDataState().jobs;

  const upsertJob = (job: TDT.ApiJob) => {
    dispatch(dataActions.upsertJob(job));
  };

  const mergeJob = (job: TDT.ApiJob) => {
    dispatch(dataActions.mergeJob(job));
  };

  const setJobs = (newJobs: TDT.ApiJob[]) => {
    dispatch(dataActions.setJobs(newJobs));
  };

  return {
    jobs,
    upsertJob,
    mergeJob,
    setJobs,
  };
};
